import { render, staticRenderFns } from "./ModelPreview.vue?vue&type=template&id=c184c80a"
import script from "./ModelPreview.vue?vue&type=script&lang=js"
export * from "./ModelPreview.vue?vue&type=script&lang=js"
import style0 from "./ModelPreview.vue?vue&type=style&index=0&id=c184c80a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports